/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlySignerAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
  type WritableSignerAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { CPMM_PROGRAM_ADDRESS } from '../programs';

export const INITIALIZE_SPOT_POOL_WITH_HOOK_DISCRIMINATOR = new Uint8Array([
  98, 227, 206, 159, 252, 134, 77, 21,
]);

export function getInitializeSpotPoolWithHookDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(
    INITIALIZE_SPOT_POOL_WITH_HOOK_DISCRIMINATOR,
  );
}

export type InitializeSpotPoolWithHookInstruction<
  TProgram extends string = typeof CPMM_PROGRAM_ADDRESS,
  TAccountConfig extends string | AccountMeta<string> = string,
  TAccountPool extends string | AccountMeta<string> = string,
  TAccountProtocolFeePosition extends string | AccountMeta<string> = string,
  TAccountProtocolFeeOwner extends string | AccountMeta<string> = string,
  TAccountAuthority extends string | AccountMeta<string> = string,
  TAccountVault0 extends string | AccountMeta<string> = string,
  TAccountVault1 extends string | AccountMeta<string> = string,
  TAccountToken0Mint extends string | AccountMeta<string> = string,
  TAccountToken1Mint extends string | AccountMeta<string> = string,
  TAccountPayer extends string | AccountMeta<string> = string,
  TAccountToken0Program extends string | AccountMeta<string> = string,
  TAccountToken1Program extends string | AccountMeta<string> = string,
  TAccountSystemProgram extends string | AccountMeta<string> =
    '11111111111111111111111111111111',
  TAccountRent extends string | AccountMeta<string> =
    'SysvarRent111111111111111111111111111111111',
  TAccountMigrationAuthority extends string | AccountMeta<string> = string,
  TAccountHookProgram extends string | AccountMeta<string> = string,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountConfig extends string
        ? ReadonlyAccount<TAccountConfig>
        : TAccountConfig,
      TAccountPool extends string
        ? WritableAccount<TAccountPool>
        : TAccountPool,
      TAccountProtocolFeePosition extends string
        ? WritableAccount<TAccountProtocolFeePosition>
        : TAccountProtocolFeePosition,
      TAccountProtocolFeeOwner extends string
        ? ReadonlyAccount<TAccountProtocolFeeOwner>
        : TAccountProtocolFeeOwner,
      TAccountAuthority extends string
        ? ReadonlyAccount<TAccountAuthority>
        : TAccountAuthority,
      TAccountVault0 extends string
        ? WritableAccount<TAccountVault0>
        : TAccountVault0,
      TAccountVault1 extends string
        ? WritableAccount<TAccountVault1>
        : TAccountVault1,
      TAccountToken0Mint extends string
        ? ReadonlyAccount<TAccountToken0Mint>
        : TAccountToken0Mint,
      TAccountToken1Mint extends string
        ? ReadonlyAccount<TAccountToken1Mint>
        : TAccountToken1Mint,
      TAccountPayer extends string
        ? WritableSignerAccount<TAccountPayer> &
            AccountSignerMeta<TAccountPayer>
        : TAccountPayer,
      TAccountToken0Program extends string
        ? ReadonlyAccount<TAccountToken0Program>
        : TAccountToken0Program,
      TAccountToken1Program extends string
        ? ReadonlyAccount<TAccountToken1Program>
        : TAccountToken1Program,
      TAccountSystemProgram extends string
        ? ReadonlyAccount<TAccountSystemProgram>
        : TAccountSystemProgram,
      TAccountRent extends string
        ? ReadonlyAccount<TAccountRent>
        : TAccountRent,
      TAccountMigrationAuthority extends string
        ? ReadonlySignerAccount<TAccountMigrationAuthority> &
            AccountSignerMeta<TAccountMigrationAuthority>
        : TAccountMigrationAuthority,
      TAccountHookProgram extends string
        ? ReadonlyAccount<TAccountHookProgram>
        : TAccountHookProgram,
      ...TRemainingAccounts,
    ]
  >;

export type InitializeSpotPoolWithHookInstructionData = {
  discriminator: ReadonlyUint8Array;
  mintA: Address;
  mintB: Address;
  swapFeeBps: number;
  hookProgram: Address;
  hookFlags: number;
};

export type InitializeSpotPoolWithHookInstructionDataArgs = {
  mintA: Address;
  mintB: Address;
  swapFeeBps: number;
  hookProgram: Address;
  hookFlags: number;
};

export function getInitializeSpotPoolWithHookInstructionDataEncoder(): FixedSizeEncoder<InitializeSpotPoolWithHookInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([
      ['discriminator', fixEncoderSize(getBytesEncoder(), 8)],
      ['mintA', getAddressEncoder()],
      ['mintB', getAddressEncoder()],
      ['swapFeeBps', getU16Encoder()],
      ['hookProgram', getAddressEncoder()],
      ['hookFlags', getU32Encoder()],
    ]),
    (value) => ({
      ...value,
      discriminator: INITIALIZE_SPOT_POOL_WITH_HOOK_DISCRIMINATOR,
    }),
  );
}

export function getInitializeSpotPoolWithHookInstructionDataDecoder(): FixedSizeDecoder<InitializeSpotPoolWithHookInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
    ['mintA', getAddressDecoder()],
    ['mintB', getAddressDecoder()],
    ['swapFeeBps', getU16Decoder()],
    ['hookProgram', getAddressDecoder()],
    ['hookFlags', getU32Decoder()],
  ]);
}

export function getInitializeSpotPoolWithHookInstructionDataCodec(): FixedSizeCodec<
  InitializeSpotPoolWithHookInstructionDataArgs,
  InitializeSpotPoolWithHookInstructionData
> {
  return combineCodec(
    getInitializeSpotPoolWithHookInstructionDataEncoder(),
    getInitializeSpotPoolWithHookInstructionDataDecoder(),
  );
}

export type InitializeSpotPoolWithHookAsyncInput<
  TAccountConfig extends string = string,
  TAccountPool extends string = string,
  TAccountProtocolFeePosition extends string = string,
  TAccountProtocolFeeOwner extends string = string,
  TAccountAuthority extends string = string,
  TAccountVault0 extends string = string,
  TAccountVault1 extends string = string,
  TAccountToken0Mint extends string = string,
  TAccountToken1Mint extends string = string,
  TAccountPayer extends string = string,
  TAccountToken0Program extends string = string,
  TAccountToken1Program extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountRent extends string = string,
  TAccountMigrationAuthority extends string = string,
  TAccountHookProgram extends string = string,
> = {
  config: Address<TAccountConfig>;
  pool: Address<TAccountPool>;
  protocolFeePosition?: Address<TAccountProtocolFeePosition>;
  protocolFeeOwner?: Address<TAccountProtocolFeeOwner>;
  authority?: Address<TAccountAuthority>;
  vault0?: Address<TAccountVault0>;
  vault1?: Address<TAccountVault1>;
  token0Mint: Address<TAccountToken0Mint>;
  token1Mint: Address<TAccountToken1Mint>;
  payer: TransactionSigner<TAccountPayer>;
  token0Program: Address<TAccountToken0Program>;
  token1Program: Address<TAccountToken1Program>;
  systemProgram?: Address<TAccountSystemProgram>;
  rent?: Address<TAccountRent>;
  migrationAuthority: TransactionSigner<TAccountMigrationAuthority>;
  /**
   * `args.hook_program` and required to be executable, which rules out the
   * common way of bricking an immutable pool: a typo'd address that is not a
   * program at all. It does NOT prove the program implements the hook ABI —
   * an executable that never `set_return_data`s a 32-byte `HookResultV1`
   * still fails every before-swap CPI with `HookReturnDataMissing`. The
   * handler additionally rejects the pool's own token programs, which
   * `swap_exact_in`'s denylist would otherwise skip before they could be
   * bound as the hook program account.
   */
  hookProgram: Address<TAccountHookProgram>;
  mintA: InitializeSpotPoolWithHookInstructionDataArgs['mintA'];
  mintB: InitializeSpotPoolWithHookInstructionDataArgs['mintB'];
  swapFeeBps: InitializeSpotPoolWithHookInstructionDataArgs['swapFeeBps'];
  hookProgramArg: InitializeSpotPoolWithHookInstructionDataArgs['hookProgram'];
  hookFlags: InitializeSpotPoolWithHookInstructionDataArgs['hookFlags'];
};

export async function getInitializeSpotPoolWithHookInstructionAsync<
  TAccountConfig extends string,
  TAccountPool extends string,
  TAccountProtocolFeePosition extends string,
  TAccountProtocolFeeOwner extends string,
  TAccountAuthority extends string,
  TAccountVault0 extends string,
  TAccountVault1 extends string,
  TAccountToken0Mint extends string,
  TAccountToken1Mint extends string,
  TAccountPayer extends string,
  TAccountToken0Program extends string,
  TAccountToken1Program extends string,
  TAccountSystemProgram extends string,
  TAccountRent extends string,
  TAccountMigrationAuthority extends string,
  TAccountHookProgram extends string,
  TProgramAddress extends Address = typeof CPMM_PROGRAM_ADDRESS,
>(
  input: InitializeSpotPoolWithHookAsyncInput<
    TAccountConfig,
    TAccountPool,
    TAccountProtocolFeePosition,
    TAccountProtocolFeeOwner,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPayer,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMigrationAuthority,
    TAccountHookProgram
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  InitializeSpotPoolWithHookInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountPool,
    TAccountProtocolFeePosition,
    TAccountProtocolFeeOwner,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPayer,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMigrationAuthority,
    TAccountHookProgram
  >
> {
  // Program address.
  const programAddress = config?.programAddress ?? CPMM_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    config: { value: input.config ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: true },
    protocolFeePosition: {
      value: input.protocolFeePosition ?? null,
      isWritable: true,
    },
    protocolFeeOwner: {
      value: input.protocolFeeOwner ?? null,
      isWritable: false,
    },
    authority: { value: input.authority ?? null, isWritable: false },
    vault0: { value: input.vault0 ?? null, isWritable: true },
    vault1: { value: input.vault1 ?? null, isWritable: true },
    token0Mint: { value: input.token0Mint ?? null, isWritable: false },
    token1Mint: { value: input.token1Mint ?? null, isWritable: false },
    payer: { value: input.payer ?? null, isWritable: true },
    token0Program: { value: input.token0Program ?? null, isWritable: false },
    token1Program: { value: input.token1Program ?? null, isWritable: false },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    rent: { value: input.rent ?? null, isWritable: false },
    migrationAuthority: {
      value: input.migrationAuthority ?? null,
      isWritable: false,
    },
    hookProgram: { value: input.hookProgram ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input, hookProgram: input.hookProgramArg };

  // Resolve default values.
  if (!accounts.protocolFeeOwner.value) {
    accounts.protocolFeeOwner.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            112, 114, 111, 116, 111, 99, 111, 108, 95, 102, 101, 101, 95, 111,
            119, 110, 101, 114,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount('pool', accounts.pool.value),
        ),
      ],
    });
  }
  if (!accounts.protocolFeePosition.value) {
    accounts.protocolFeePosition.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([112, 111, 115, 105, 116, 105, 111, 110]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount('pool', accounts.pool.value),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'protocolFeeOwner',
            accounts.protocolFeeOwner.value,
          ),
        ),
        getBytesEncoder().encode(new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0])),
      ],
    });
  }
  if (!accounts.authority.value) {
    accounts.authority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([97, 117, 116, 104, 111, 114, 105, 116, 121]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount('pool', accounts.pool.value),
        ),
      ],
    });
  }
  if (!accounts.vault0.value) {
    accounts.vault0.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(new Uint8Array([118, 97, 117, 108, 116, 48])),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount('pool', accounts.pool.value),
        ),
      ],
    });
  }
  if (!accounts.vault1.value) {
    accounts.vault1.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(new Uint8Array([118, 97, 117, 108, 116, 49])),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount('pool', accounts.pool.value),
        ),
      ],
    });
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }
  if (!accounts.rent.value) {
    accounts.rent.value =
      'SysvarRent111111111111111111111111111111111' as Address<'SysvarRent111111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('config', accounts.config),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('protocolFeePosition', accounts.protocolFeePosition),
      getAccountMeta('protocolFeeOwner', accounts.protocolFeeOwner),
      getAccountMeta('authority', accounts.authority),
      getAccountMeta('vault0', accounts.vault0),
      getAccountMeta('vault1', accounts.vault1),
      getAccountMeta('token0Mint', accounts.token0Mint),
      getAccountMeta('token1Mint', accounts.token1Mint),
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('token0Program', accounts.token0Program),
      getAccountMeta('token1Program', accounts.token1Program),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('rent', accounts.rent),
      getAccountMeta('migrationAuthority', accounts.migrationAuthority),
      getAccountMeta('hookProgram', accounts.hookProgram),
    ],
    data: getInitializeSpotPoolWithHookInstructionDataEncoder().encode(
      args as InitializeSpotPoolWithHookInstructionDataArgs,
    ),
    programAddress,
  } as InitializeSpotPoolWithHookInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountPool,
    TAccountProtocolFeePosition,
    TAccountProtocolFeeOwner,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPayer,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMigrationAuthority,
    TAccountHookProgram
  >);
}

export type InitializeSpotPoolWithHookInput<
  TAccountConfig extends string = string,
  TAccountPool extends string = string,
  TAccountProtocolFeePosition extends string = string,
  TAccountProtocolFeeOwner extends string = string,
  TAccountAuthority extends string = string,
  TAccountVault0 extends string = string,
  TAccountVault1 extends string = string,
  TAccountToken0Mint extends string = string,
  TAccountToken1Mint extends string = string,
  TAccountPayer extends string = string,
  TAccountToken0Program extends string = string,
  TAccountToken1Program extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountRent extends string = string,
  TAccountMigrationAuthority extends string = string,
  TAccountHookProgram extends string = string,
> = {
  config: Address<TAccountConfig>;
  pool: Address<TAccountPool>;
  protocolFeePosition: Address<TAccountProtocolFeePosition>;
  protocolFeeOwner: Address<TAccountProtocolFeeOwner>;
  authority: Address<TAccountAuthority>;
  vault0: Address<TAccountVault0>;
  vault1: Address<TAccountVault1>;
  token0Mint: Address<TAccountToken0Mint>;
  token1Mint: Address<TAccountToken1Mint>;
  payer: TransactionSigner<TAccountPayer>;
  token0Program: Address<TAccountToken0Program>;
  token1Program: Address<TAccountToken1Program>;
  systemProgram?: Address<TAccountSystemProgram>;
  rent?: Address<TAccountRent>;
  migrationAuthority: TransactionSigner<TAccountMigrationAuthority>;
  /**
   * `args.hook_program` and required to be executable, which rules out the
   * common way of bricking an immutable pool: a typo'd address that is not a
   * program at all. It does NOT prove the program implements the hook ABI —
   * an executable that never `set_return_data`s a 32-byte `HookResultV1`
   * still fails every before-swap CPI with `HookReturnDataMissing`. The
   * handler additionally rejects the pool's own token programs, which
   * `swap_exact_in`'s denylist would otherwise skip before they could be
   * bound as the hook program account.
   */
  hookProgram: Address<TAccountHookProgram>;
  mintA: InitializeSpotPoolWithHookInstructionDataArgs['mintA'];
  mintB: InitializeSpotPoolWithHookInstructionDataArgs['mintB'];
  swapFeeBps: InitializeSpotPoolWithHookInstructionDataArgs['swapFeeBps'];
  hookProgramArg: InitializeSpotPoolWithHookInstructionDataArgs['hookProgram'];
  hookFlags: InitializeSpotPoolWithHookInstructionDataArgs['hookFlags'];
};

export function getInitializeSpotPoolWithHookInstruction<
  TAccountConfig extends string,
  TAccountPool extends string,
  TAccountProtocolFeePosition extends string,
  TAccountProtocolFeeOwner extends string,
  TAccountAuthority extends string,
  TAccountVault0 extends string,
  TAccountVault1 extends string,
  TAccountToken0Mint extends string,
  TAccountToken1Mint extends string,
  TAccountPayer extends string,
  TAccountToken0Program extends string,
  TAccountToken1Program extends string,
  TAccountSystemProgram extends string,
  TAccountRent extends string,
  TAccountMigrationAuthority extends string,
  TAccountHookProgram extends string,
  TProgramAddress extends Address = typeof CPMM_PROGRAM_ADDRESS,
>(
  input: InitializeSpotPoolWithHookInput<
    TAccountConfig,
    TAccountPool,
    TAccountProtocolFeePosition,
    TAccountProtocolFeeOwner,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPayer,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMigrationAuthority,
    TAccountHookProgram
  >,
  config?: { programAddress?: TProgramAddress },
): InitializeSpotPoolWithHookInstruction<
  TProgramAddress,
  TAccountConfig,
  TAccountPool,
  TAccountProtocolFeePosition,
  TAccountProtocolFeeOwner,
  TAccountAuthority,
  TAccountVault0,
  TAccountVault1,
  TAccountToken0Mint,
  TAccountToken1Mint,
  TAccountPayer,
  TAccountToken0Program,
  TAccountToken1Program,
  TAccountSystemProgram,
  TAccountRent,
  TAccountMigrationAuthority,
  TAccountHookProgram
> {
  // Program address.
  const programAddress = config?.programAddress ?? CPMM_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    config: { value: input.config ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: true },
    protocolFeePosition: {
      value: input.protocolFeePosition ?? null,
      isWritable: true,
    },
    protocolFeeOwner: {
      value: input.protocolFeeOwner ?? null,
      isWritable: false,
    },
    authority: { value: input.authority ?? null, isWritable: false },
    vault0: { value: input.vault0 ?? null, isWritable: true },
    vault1: { value: input.vault1 ?? null, isWritable: true },
    token0Mint: { value: input.token0Mint ?? null, isWritable: false },
    token1Mint: { value: input.token1Mint ?? null, isWritable: false },
    payer: { value: input.payer ?? null, isWritable: true },
    token0Program: { value: input.token0Program ?? null, isWritable: false },
    token1Program: { value: input.token1Program ?? null, isWritable: false },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    rent: { value: input.rent ?? null, isWritable: false },
    migrationAuthority: {
      value: input.migrationAuthority ?? null,
      isWritable: false,
    },
    hookProgram: { value: input.hookProgram ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input, hookProgram: input.hookProgramArg };

  // Resolve default values.
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }
  if (!accounts.rent.value) {
    accounts.rent.value =
      'SysvarRent111111111111111111111111111111111' as Address<'SysvarRent111111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('config', accounts.config),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('protocolFeePosition', accounts.protocolFeePosition),
      getAccountMeta('protocolFeeOwner', accounts.protocolFeeOwner),
      getAccountMeta('authority', accounts.authority),
      getAccountMeta('vault0', accounts.vault0),
      getAccountMeta('vault1', accounts.vault1),
      getAccountMeta('token0Mint', accounts.token0Mint),
      getAccountMeta('token1Mint', accounts.token1Mint),
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('token0Program', accounts.token0Program),
      getAccountMeta('token1Program', accounts.token1Program),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('rent', accounts.rent),
      getAccountMeta('migrationAuthority', accounts.migrationAuthority),
      getAccountMeta('hookProgram', accounts.hookProgram),
    ],
    data: getInitializeSpotPoolWithHookInstructionDataEncoder().encode(
      args as InitializeSpotPoolWithHookInstructionDataArgs,
    ),
    programAddress,
  } as InitializeSpotPoolWithHookInstruction<
    TProgramAddress,
    TAccountConfig,
    TAccountPool,
    TAccountProtocolFeePosition,
    TAccountProtocolFeeOwner,
    TAccountAuthority,
    TAccountVault0,
    TAccountVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPayer,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountMigrationAuthority,
    TAccountHookProgram
  >);
}

export type ParsedInitializeSpotPoolWithHookInstruction<
  TProgram extends string = typeof CPMM_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    config: TAccountMetas[0];
    pool: TAccountMetas[1];
    protocolFeePosition: TAccountMetas[2];
    protocolFeeOwner: TAccountMetas[3];
    authority: TAccountMetas[4];
    vault0: TAccountMetas[5];
    vault1: TAccountMetas[6];
    token0Mint: TAccountMetas[7];
    token1Mint: TAccountMetas[8];
    payer: TAccountMetas[9];
    token0Program: TAccountMetas[10];
    token1Program: TAccountMetas[11];
    systemProgram: TAccountMetas[12];
    rent: TAccountMetas[13];
    migrationAuthority: TAccountMetas[14];
    /**
     * `args.hook_program` and required to be executable, which rules out the
     * common way of bricking an immutable pool: a typo'd address that is not a
     * program at all. It does NOT prove the program implements the hook ABI —
     * an executable that never `set_return_data`s a 32-byte `HookResultV1`
     * still fails every before-swap CPI with `HookReturnDataMissing`. The
     * handler additionally rejects the pool's own token programs, which
     * `swap_exact_in`'s denylist would otherwise skip before they could be
     * bound as the hook program account.
     */
    hookProgram: TAccountMetas[15];
  };
  data: InitializeSpotPoolWithHookInstructionData;
};

export function parseInitializeSpotPoolWithHookInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedInitializeSpotPoolWithHookInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 16) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 16,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      config: getNextAccount(),
      pool: getNextAccount(),
      protocolFeePosition: getNextAccount(),
      protocolFeeOwner: getNextAccount(),
      authority: getNextAccount(),
      vault0: getNextAccount(),
      vault1: getNextAccount(),
      token0Mint: getNextAccount(),
      token1Mint: getNextAccount(),
      payer: getNextAccount(),
      token0Program: getNextAccount(),
      token1Program: getNextAccount(),
      systemProgram: getNextAccount(),
      rent: getNextAccount(),
      migrationAuthority: getNextAccount(),
      hookProgram: getNextAccount(),
    },
    data: getInitializeSpotPoolWithHookInstructionDataDecoder().decode(
      instruction.data,
    ),
  };
}
